export default "__VITE_ASSET__CFbIvHSa__"